import { Button, ButtonSize, ButtonVariant } from "shared/components";

export const UnhandledError = ({ errorMessage }: { errorMessage: string }) => {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-alpha-40 p-4">
      <div className="m-4 w-full max-w-md rounded-lg bg-white p-6 shadow-xl">
        <h4 className="mb-3 text-lg font-bold text-content-700">
          Sorry, that wasn’t supposed to happen!
        </h4>
        <p className="mb-3 text-content-500">
          Something went wrong. It may be a temporary problem, or it may be an
          issue with our service, but our team is already on it.
        </p>
        <p className="mb-3 text-danger-500">
          Here&apos;s what we know about the error: {errorMessage}.
        </p>
        <p className="mb-3 text-content-500">
          Your data is encrypted and stored with bank-level security.
        </p>
        <Button
          variant={ButtonVariant.BASE}
          size={ButtonSize.SM}
          onClick={() => window.location.reload()}
        >
          Reload
        </Button>
      </div>
    </div>
  );
};
